import { liveHomeCopy as enLiveHomeCopy } from "@/content/pages/en/live-home";

import { StaticEquityCard } from "./equity-card";
import { StaticGuaranteesCard } from "./guarantees-card";
import { StaticPricingCard } from "./pricing-card";
import { StaticRepaymentCard } from "./repayment-card";
import { StaticSpendCard } from "./spend-card";
import type { TermsCopy } from "./types";

/** Pre-Rive homepage terms bento — static HTML reference (Figma 6055:30123). */
export function StaticTermsGrid({
  copy = enLiveHomeCopy.terms,
}: {
  copy?: TermsCopy;
}) {
  return (
    // Mobile (Figma 4081:22788): 24px between heading and cards; desktop 32px.
    <div className="flex flex-col gap-6 lg:gap-8">
      <h2 className="text-grey-950 w-full text-[24px] leading-[1.2] tracking-[-0.04em] text-balance md:text-[28px] lg:text-[32px]">
        <span className="lg:hidden">{copy.headingMobile}</span>
        <span className="hidden lg:inline">{copy.headingDesktop}</span>
      </h2>

      <div className="flex flex-col gap-6 lg:gap-5">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-5">
          <StaticPricingCard copy={copy} />
          <StaticRepaymentCard copy={copy} />
        </div>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-5">
          <StaticEquityCard copy={copy} />
          <StaticSpendCard copy={copy} />
          <StaticGuaranteesCard copy={copy} />
        </div>
      </div>
    </div>
  );
}
